import { render, staticRenderFns } from "./NotificationEnquiryCommentCard.vue?vue&type=template&id=501d625b&"
import script from "./NotificationEnquiryCommentCard.vue?vue&type=script&lang=js&"
export * from "./NotificationEnquiryCommentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports